export const openCalendly = (e) => {
  if (e) e.preventDefault();
  const url = process.env.REACT_APP_CALENDLY_URL;
  if (!url) return;
  if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
    window.Calendly.initPopupWidget({ url });
  } else {
    window.open(url, "_blank", "noopener");
  }
};
